/**
 * @file Helpers and utils for route-related logic.
 */

import ROUTES from 'constants/routes'

export const isDashboardPath = (path: string) =>
  path.includes(ROUTES.DASHBOARDS.DASHBOARD)

/**
 * Returns the path with the base path prepended.
 * Useful for linking to stuff in `public/` from the app.
 */
export const getPublicPath = <const TPath extends string>(path: TPath) => {
  return `${process.env.BASE_PATH}${path}` as const
}
